import styled from '@emotion/styled'

export const ValueDiv = styled.div`
  flex-shrink: 0;
`

export const LabelDiv = styled.div`
  flex-shrink: 0;
  font-weight: bold;
`

export const Spacer = styled.div`
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &::before {
    content: '....................................................................................................';
    float: left;
  }
  &::after {
    content: ' ';
    clear: both;
  }
`
